import Swal from "sweetalert2";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxLimeStone } from "../../Limestone/AxLimeStone";
import { ModuleName } from "../../Lib/AxSystem/AxInit";

@ModuleName("B2bMode")
export class B2bMode {
    constructor(private _AxLimestone = new AxLimeStone(), private _i18nHelper = new I18nHelper) {
        this.Init();
    }

    Init(): void {
        if ($("#BtnB2bLogin").length > 0) {
            $("#BtnB2bLogin").click(e => {
                this._AxLimestone.LockButton(e.delegateTarget);
                this.B2bLogin();
            });
        }
        else {
            $("#BtnB2bLoadHistory").click(e => {
                this._AxLimestone.LockButton(e.delegateTarget);
                this.B2bLoadHistory();
            });
            this.InitB2BDwnLdBtns();
        }
    }

    B2bLogin() {
        let url = $("#Form_B2B_WTP_Login").data("action") as string;
        let errTitle = this._i18nHelper.GetTranslation(Translations.Error);
        let that = this;
        $.ajax({
            url: url,
            data: {
                "LoginId": $("#B2bLoginId").val(),
                "Username": $("#B2bUsername").val(),
                "Password": $("#B2bPassword").val()
            },
            method: "POST",
            success: function (result) {
                if (result.ErrorCode == 0) {
                    if (result.AciveLimits) {
                        location.href = url.replace(/\/Login/, "/Limits");
                    }
                    else {
                        location.href = url.replace(/\/B2B\/Login/, "/Home");
                    }
                    return false;
                }

                Swal.fire({
                    title: errTitle,
                    text: result.ErrorMessage,
                    icon: "error",
                    position: "top",
                    customClass: {
                        closeButton: "ax-btn ax-btn-secondary"
                    },
                    showCancelButton: false
                });
                that._AxLimestone.UnlockAllButtons();
            },
            error: function () {
                that._AxLimestone.UnlockAllButtons();
            }
        });

    }

    B2bLoad(url: any, callback: Function) {
        let errTitle = this._i18nHelper.GetTranslation(Translations.Error);
        $.ajax({
            url: url,
            data: $(this).serialize(),
            dataType: 'binary',
            xhrFields: {
                'responseType': 'blob'
            },
            success: function (data, status, xhr) {
                //$('#loader').hide();
                // if(data.type.indexOf('text/html') != -1){//If instead of a file you get an error page
                //     var reader = new FileReader();
                //     reader.readAsText(data);
                //     reader.onload = function() {alert(reader.result);};
                //     return;
                // }
                let link = document.createElement('a'), filename = 'File.pdf';

                if (xhr.getResponseHeader('Content-Disposition')) { //filename 
                    filename = xhr.getResponseHeader('Content-Disposition');
                    filename = decodeURIComponent(filename.match(/filename\*?=([^']*'')?([^;]*)/)[2]);
                }

                link.href = URL.createObjectURL(data);
                link.download = filename;
                link.click();
                callback();
            },
            error: function (xhr, ajaxOptions, thrownError) {
                Swal.fire({
                    title: errTitle,
                    text: 'Got unknown answer from the Server.',
                    icon: 'error'
                });
                callback();
            }
        });
    }

    InitB2BDwnLdBtns() {
        $("#SalesHistoryListTbl td.b2b-download a[data-url]").click(e => {
            e.stopPropagation();
            e.preventDefault();
            let target = $(e.currentTarget);
            let laEl = target.find('i');

            if (laEl.hasClass("b2bDownloadAni")) {
                return;
            }

            let isInvoice = laEl.hasClass("la-file-invoice");

            laEl.removeClass(isInvoice ? "la-file-invoice" : "la-ticket-alt").addClass("la-download b2bDownloadAni");
            this.B2bLoad($(e.currentTarget).data("url"),
                function () {
                    laEl.addClass(isInvoice ? "la-file-invoice" : "la-ticket-alt").removeClass("la-download b2bDownloadAni");
                });
        });
    }

    B2bLoadHistory() {
        //let InitB2BDwnLdBtns = this.InitB2BDwnLdBtns;
        let that = this;
        AxessViewer.loadPartialView('/B2B/History',
            {
                'StartDate': $("#B2bSalesHistFilterStartDate").val(),
                'EndDate': $("#B2bSalesHistFilterEndDate").val()
            }, function (result) {
                $('#b2bSalesHistoryListContainer').html(result);
                that.InitB2BDwnLdBtns();
                that._AxLimestone.UnlockAllButtons();
            },
            {
                dataType: 'html'
            });
    }
}